import { computed as I, ref as nt, shallowRef as jt, watch as dt, getCurrentScope as Yt, onScopeDispose as qt, shallowReadonly as G, unref as Xt } from "vue";
const j = Math.min, S = Math.max, rt = Math.round, st = Math.floor, k = (t) => ({
  x: t,
  y: t
}), Ut = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Kt = {
  start: "end",
  end: "start"
};
function ht(t, e, n) {
  return S(t, j(e, n));
}
function tt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Y(t) {
  return t.split("-")[0];
}
function et(t) {
  return t.split("-")[1];
}
function Ft(t) {
  return t === "x" ? "y" : "x";
}
function xt(t) {
  return t === "y" ? "height" : "width";
}
const Gt = /* @__PURE__ */ new Set(["top", "bottom"]);
function $(t) {
  return Gt.has(Y(t)) ? "y" : "x";
}
function yt(t) {
  return Ft($(t));
}
function Jt(t, e, n) {
  n === void 0 && (n = !1);
  const o = et(t), i = yt(t), r = xt(i);
  let s = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (s = lt(s)), [s, lt(s)];
}
function Qt(t) {
  const e = lt(t);
  return [gt(t), e, gt(e)];
}
function gt(t) {
  return t.replace(/start|end/g, (e) => Kt[e]);
}
const Et = ["left", "right"], St = ["right", "left"], Zt = ["top", "bottom"], te = ["bottom", "top"];
function ee(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? St : Et : e ? Et : St;
    case "left":
    case "right":
      return e ? Zt : te;
    default:
      return [];
  }
}
function ne(t, e, n, o) {
  const i = et(t);
  let r = ee(Y(t), n === "start", o);
  return i && (r = r.map((s) => s + "-" + i), e && (r = r.concat(r.map(gt)))), r;
}
function lt(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Ut[e]);
}
function oe(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Mt(t) {
  return typeof t != "number" ? oe(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ct(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Dt(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const r = $(e), s = yt(e), l = xt(s), f = Y(e), c = r === "y", a = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, h = o[l] / 2 - i[l] / 2;
  let u;
  switch (f) {
    case "top":
      u = {
        x: a,
        y: o.y - i.height
      };
      break;
    case "bottom":
      u = {
        x: a,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      u = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (et(e)) {
    case "start":
      u[s] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      u[s] += h * (n && c ? -1 : 1);
      break;
  }
  return u;
}
const ie = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: s
  } = n, l = r.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: a,
    y: d
  } = Dt(c, o, f), h = o, u = {}, m = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: p,
      fn: w
    } = l[g], {
      x,
      y: v,
      data: O,
      reset: b
    } = await w({
      x: a,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: i,
      middlewareData: u,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    a = x ?? a, d = v ?? d, u = {
      ...u,
      [p]: {
        ...u[p],
        ...O
      }
    }, b && m <= 50 && (m++, typeof b == "object" && (b.placement && (h = b.placement), b.rects && (c = b.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : b.rects), {
      x: a,
      y: d
    } = Dt(c, h, f)), g = -1);
  }
  return {
    x: a,
    y: d,
    placement: h,
    strategy: i,
    middlewareData: u
  };
};
async function vt(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: s,
    elements: l,
    strategy: f
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: a = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: u = 0
  } = tt(e, t), m = Mt(u), p = l[h ? d === "floating" ? "reference" : "floating" : d], w = ct(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(p))) == null || n ? p : p.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: a,
    strategy: f
  })), x = d === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, v = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(l.floating)), O = await (r.isElement == null ? void 0 : r.isElement(v)) ? await (r.getScale == null ? void 0 : r.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = ct(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: x,
    offsetParent: v,
    strategy: f
  }) : x);
  return {
    top: (w.top - b.top + m.top) / O.y,
    bottom: (b.bottom - w.bottom + m.bottom) / O.y,
    left: (w.left - b.left + m.left) / O.x,
    right: (b.right - w.right + m.right) / O.x
  };
}
const se = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: r,
      platform: s,
      elements: l,
      middlewareData: f
    } = e, {
      element: c,
      padding: a = 0
    } = tt(t, e) || {};
    if (c == null)
      return {};
    const d = Mt(a), h = {
      x: n,
      y: o
    }, u = yt(i), m = xt(u), g = await s.getDimensions(c), p = u === "y", w = p ? "top" : "left", x = p ? "bottom" : "right", v = p ? "clientHeight" : "clientWidth", O = r.reference[m] + r.reference[u] - h[u] - r.floating[m], b = h[u] - r.reference[u], C = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let y = C ? C[v] : 0;
    (!y || !await (s.isElement == null ? void 0 : s.isElement(C))) && (y = l.floating[v] || r.floating[m]);
    const A = O / 2 - b / 2, E = y / 2 - g[m] / 2 - 1, T = j(d[w], E), _ = j(d[x], E), M = T, H = y - g[m] - _, R = y / 2 - g[m] / 2 + A, X = ht(M, R, H), N = !f.arrow && et(i) != null && R !== X && r.reference[m] / 2 - (R < M ? T : _) - g[m] / 2 < 0, L = N ? R < M ? R - M : R - H : 0;
    return {
      [u]: h[u] + L,
      data: {
        [u]: X,
        centerOffset: R - X - L,
        ...N && {
          alignmentOffset: L
        }
      },
      reset: N
    };
  }
}), re = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: r,
        rects: s,
        initialPlacement: l,
        platform: f,
        elements: c
      } = e, {
        mainAxis: a = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...p
      } = tt(t, e);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const w = Y(i), x = $(l), v = Y(l) === l, O = await (f.isRTL == null ? void 0 : f.isRTL(c.floating)), b = h || (v || !g ? [lt(l)] : Qt(l)), C = m !== "none";
      !h && C && b.push(...ne(l, g, m, O));
      const y = [l, ...b], A = await vt(e, p), E = [];
      let T = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (a && E.push(A[w]), d) {
        const R = Jt(i, s, O);
        E.push(A[R[0]], A[R[1]]);
      }
      if (T = [...T, {
        placement: i,
        overflows: E
      }], !E.every((R) => R <= 0)) {
        var _, M;
        const R = (((_ = r.flip) == null ? void 0 : _.index) || 0) + 1, X = y[R];
        if (X && (!(d === "alignment" ? x !== $(X) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((P) => P.overflows[0] > 0 && $(P.placement) === x)))
          return {
            data: {
              index: R,
              overflows: T
            },
            reset: {
              placement: X
            }
          };
        let N = (M = T.filter((L) => L.overflows[0] <= 0).sort((L, P) => L.overflows[1] - P.overflows[1])[0]) == null ? void 0 : M.placement;
        if (!N)
          switch (u) {
            case "bestFit": {
              var H;
              const L = (H = T.filter((P) => {
                if (C) {
                  const z = $(P.placement);
                  return z === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  z === "y";
                }
                return !0;
              }).map((P) => [P.placement, P.overflows.filter((z) => z > 0).reduce((z, It) => z + It, 0)]).sort((P, z) => P[1] - z[1])[0]) == null ? void 0 : H[0];
              L && (N = L);
              break;
            }
            case "initialPlacement":
              N = l;
              break;
          }
        if (i !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
}, le = /* @__PURE__ */ new Set(["left", "top"]);
async function ce(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = Y(n), l = et(n), f = $(n) === "y", c = le.has(s) ? -1 : 1, a = r && f ? -1 : 1, d = tt(e, t);
  let {
    mainAxis: h,
    crossAxis: u,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return l && typeof m == "number" && (u = l === "end" ? m * -1 : m), f ? {
    x: u * a,
    y: h * c
  } : {
    x: h * c,
    y: u * a
  };
}
const ae = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: r,
        placement: s,
        middlewareData: l
      } = e, f = await ce(e, t);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + f.x,
        y: r + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, fe = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i
      } = e, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (p) => {
            let {
              x: w,
              y: x
            } = p;
            return {
              x: w,
              y: x
            };
          }
        },
        ...f
      } = tt(t, e), c = {
        x: n,
        y: o
      }, a = await vt(e, f), d = $(Y(i)), h = Ft(d);
      let u = c[h], m = c[d];
      if (r) {
        const p = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", x = u + a[p], v = u - a[w];
        u = ht(x, u, v);
      }
      if (s) {
        const p = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", x = m + a[p], v = m - a[w];
        m = ht(x, m, v);
      }
      const g = l.fn({
        ...e,
        [h]: u,
        [d]: m
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - o,
          enabled: {
            [h]: r,
            [d]: s
          }
        }
      };
    }
  };
}, ue = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        rects: r,
        platform: s,
        elements: l
      } = e, {
        apply: f = () => {
        },
        ...c
      } = tt(t, e), a = await vt(e, c), d = Y(i), h = et(i), u = $(i) === "y", {
        width: m,
        height: g
      } = r.floating;
      let p, w;
      d === "top" || d === "bottom" ? (p = d, w = h === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (w = d, p = h === "end" ? "top" : "bottom");
      const x = g - a.top - a.bottom, v = m - a.left - a.right, O = j(g - a[p], x), b = j(m - a[w], v), C = !e.middlewareData.shift;
      let y = O, A = b;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (A = v), (o = e.middlewareData.shift) != null && o.enabled.y && (y = x), C && !h) {
        const T = S(a.left, 0), _ = S(a.right, 0), M = S(a.top, 0), H = S(a.bottom, 0);
        u ? A = m - 2 * (T !== 0 || _ !== 0 ? T + _ : S(a.left, a.right)) : y = g - 2 * (M !== 0 || H !== 0 ? M + H : S(a.top, a.bottom));
      }
      await f({
        ...e,
        availableWidth: A,
        availableHeight: y
      });
      const E = await s.getDimensions(l.floating);
      return m !== E.width || g !== E.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function at() {
  return typeof window < "u";
}
function K(t) {
  return bt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function D(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function B(t) {
  var e;
  return (e = (bt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function bt(t) {
  return at() ? t instanceof Node || t instanceof D(t).Node : !1;
}
function V(t) {
  return at() ? t instanceof Element || t instanceof D(t).Element : !1;
}
function W(t) {
  return at() ? t instanceof HTMLElement || t instanceof D(t).HTMLElement : !1;
}
function Tt(t) {
  return !at() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof D(t).ShadowRoot;
}
const de = /* @__PURE__ */ new Set(["inline", "contents"]);
function it(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = F(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !de.has(i);
}
const me = /* @__PURE__ */ new Set(["table", "td", "th"]);
function he(t) {
  return me.has(K(t));
}
const ge = [":popover-open", ":modal"];
function ft(t) {
  return ge.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const pe = ["transform", "translate", "scale", "rotate", "perspective"], we = ["transform", "translate", "scale", "rotate", "perspective", "filter"], xe = ["paint", "layout", "strict", "content"];
function Ot(t) {
  const e = At(), n = V(t) ? F(t) : t;
  return pe.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || we.some((o) => (n.willChange || "").includes(o)) || xe.some((o) => (n.contain || "").includes(o));
}
function ye(t) {
  let e = q(t);
  for (; W(e) && !Z(e); ) {
    if (Ot(e))
      return e;
    if (ft(e))
      return null;
    e = q(e);
  }
  return null;
}
function At() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const ve = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Z(t) {
  return ve.has(K(t));
}
function F(t) {
  return D(t).getComputedStyle(t);
}
function ut(t) {
  return V(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function q(t) {
  if (K(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Tt(t) && t.host || // Fallback.
    B(t)
  );
  return Tt(e) ? e.host : e;
}
function kt(t) {
  const e = q(t);
  return Z(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : W(e) && it(e) ? e : kt(e);
}
function ot(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = kt(t), r = i === ((o = t.ownerDocument) == null ? void 0 : o.body), s = D(i);
  if (r) {
    const l = pt(s);
    return e.concat(s, s.visualViewport || [], it(i) ? i : [], l && n ? ot(l) : []);
  }
  return e.concat(i, ot(i, [], n));
}
function pt(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Wt(t) {
  const e = F(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = W(t), r = i ? t.offsetWidth : n, s = i ? t.offsetHeight : o, l = rt(n) !== r || rt(o) !== s;
  return l && (n = r, o = s), {
    width: n,
    height: o,
    $: l
  };
}
function Rt(t) {
  return V(t) ? t : t.contextElement;
}
function Q(t) {
  const e = Rt(t);
  if (!W(e))
    return k(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = Wt(e);
  let s = (r ? rt(n.width) : n.width) / o, l = (r ? rt(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const be = /* @__PURE__ */ k(0);
function Bt(t) {
  const e = D(t);
  return !At() || !e.visualViewport ? be : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Oe(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== D(t) ? !1 : e;
}
function U(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), r = Rt(t);
  let s = k(1);
  e && (o ? V(o) && (s = Q(o)) : s = Q(t));
  const l = Oe(r, n, o) ? Bt(r) : k(0);
  let f = (i.left + l.x) / s.x, c = (i.top + l.y) / s.y, a = i.width / s.x, d = i.height / s.y;
  if (r) {
    const h = D(r), u = o && V(o) ? D(o) : o;
    let m = h, g = pt(m);
    for (; g && o && u !== m; ) {
      const p = Q(g), w = g.getBoundingClientRect(), x = F(g), v = w.left + (g.clientLeft + parseFloat(x.paddingLeft)) * p.x, O = w.top + (g.clientTop + parseFloat(x.paddingTop)) * p.y;
      f *= p.x, c *= p.y, a *= p.x, d *= p.y, f += v, c += O, m = D(g), g = pt(m);
    }
  }
  return ct({
    width: a,
    height: d,
    x: f,
    y: c
  });
}
function Ct(t, e) {
  const n = ut(t).scrollLeft;
  return e ? e.left + n : U(B(t)).left + n;
}
function Nt(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Ct(t, o)
  )), r = o.top + e.scrollTop;
  return {
    x: i,
    y: r
  };
}
function Ae(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const r = i === "fixed", s = B(o), l = e ? ft(e.floating) : !1;
  if (o === s || l && r)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = k(1);
  const a = k(0), d = W(o);
  if ((d || !d && !r) && ((K(o) !== "body" || it(s)) && (f = ut(o)), W(o))) {
    const u = U(o);
    c = Q(o), a.x = u.x + o.clientLeft, a.y = u.y + o.clientTop;
  }
  const h = s && !d && !r ? Nt(s, f, !0) : k(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - f.scrollLeft * c.x + a.x + h.x,
    y: n.y * c.y - f.scrollTop * c.y + a.y + h.y
  };
}
function Re(t) {
  return Array.from(t.getClientRects());
}
function Ce(t) {
  const e = B(t), n = ut(t), o = t.ownerDocument.body, i = S(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), r = S(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Ct(t);
  const l = -n.scrollTop;
  return F(o).direction === "rtl" && (s += S(e.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: s,
    y: l
  };
}
function Ee(t, e) {
  const n = D(t), o = B(t), i = n.visualViewport;
  let r = o.clientWidth, s = o.clientHeight, l = 0, f = 0;
  if (i) {
    r = i.width, s = i.height;
    const c = At();
    (!c || c && e === "fixed") && (l = i.offsetLeft, f = i.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: l,
    y: f
  };
}
const Se = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function De(t, e) {
  const n = U(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = W(t) ? Q(t) : k(1), s = t.clientWidth * r.x, l = t.clientHeight * r.y, f = i * r.x, c = o * r.y;
  return {
    width: s,
    height: l,
    x: f,
    y: c
  };
}
function Lt(t, e, n) {
  let o;
  if (e === "viewport")
    o = Ee(t, n);
  else if (e === "document")
    o = Ce(B(t));
  else if (V(e))
    o = De(e, n);
  else {
    const i = Bt(t);
    o = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return ct(o);
}
function $t(t, e) {
  const n = q(t);
  return n === e || !V(n) || Z(n) ? !1 : F(n).position === "fixed" || $t(n, e);
}
function Te(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = ot(t, [], !1).filter((l) => V(l) && K(l) !== "body"), i = null;
  const r = F(t).position === "fixed";
  let s = r ? q(t) : t;
  for (; V(s) && !Z(s); ) {
    const l = F(s), f = Ot(s);
    !f && l.position === "fixed" && (i = null), (r ? !f && !i : !f && l.position === "static" && !!i && Se.has(i.position) || it(s) && !f && $t(t, s)) ? o = o.filter((a) => a !== s) : i = l, s = q(s);
  }
  return e.set(t, o), o;
}
function Le(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? ft(e) ? [] : Te(e, this._c) : [].concat(n), o], l = s[0], f = s.reduce((c, a) => {
    const d = Lt(e, a, i);
    return c.top = S(d.top, c.top), c.right = j(d.right, c.right), c.bottom = j(d.bottom, c.bottom), c.left = S(d.left, c.left), c;
  }, Lt(e, l, i));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function Pe(t) {
  const {
    width: e,
    height: n
  } = Wt(t);
  return {
    width: e,
    height: n
  };
}
function Ve(t, e, n) {
  const o = W(e), i = B(e), r = n === "fixed", s = U(t, !0, r, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = k(0);
  function c() {
    f.x = Ct(i);
  }
  if (o || !o && !r)
    if ((K(e) !== "body" || it(i)) && (l = ut(e)), o) {
      const u = U(e, !0, r, e);
      f.x = u.x + e.clientLeft, f.y = u.y + e.clientTop;
    } else i && c();
  r && !o && i && c();
  const a = i && !o && !r ? Nt(i, l) : k(0), d = s.left + l.scrollLeft - f.x - a.x, h = s.top + l.scrollTop - f.y - a.y;
  return {
    x: d,
    y: h,
    width: s.width,
    height: s.height
  };
}
function mt(t) {
  return F(t).position === "static";
}
function Pt(t, e) {
  if (!W(t) || F(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return B(t) === n && (n = n.ownerDocument.body), n;
}
function _t(t, e) {
  const n = D(t);
  if (ft(t))
    return n;
  if (!W(t)) {
    let i = q(t);
    for (; i && !Z(i); ) {
      if (V(i) && !mt(i))
        return i;
      i = q(i);
    }
    return n;
  }
  let o = Pt(t, e);
  for (; o && he(o) && mt(o); )
    o = Pt(o, e);
  return o && Z(o) && mt(o) && !Ot(o) ? n : o || ye(t) || n;
}
const Fe = async function(t) {
  const e = this.getOffsetParent || _t, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Ve(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Me(t) {
  return F(t).direction === "rtl";
}
const ke = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ae,
  getDocumentElement: B,
  getClippingRect: Le,
  getOffsetParent: _t,
  getElementRects: Fe,
  getClientRects: Re,
  getDimensions: Pe,
  getScale: Q,
  isElement: V,
  isRTL: Me
};
function Ht(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function We(t, e) {
  let n = null, o;
  const i = B(t);
  function r() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, f) {
    l === void 0 && (l = !1), f === void 0 && (f = 1), r();
    const c = t.getBoundingClientRect(), {
      left: a,
      top: d,
      width: h,
      height: u
    } = c;
    if (l || e(), !h || !u)
      return;
    const m = st(d), g = st(i.clientWidth - (a + h)), p = st(i.clientHeight - (d + u)), w = st(a), v = {
      rootMargin: -m + "px " + -g + "px " + -p + "px " + -w + "px",
      threshold: S(0, j(1, f)) || 1
    };
    let O = !0;
    function b(C) {
      const y = C[0].intersectionRatio;
      if (y !== f) {
        if (!O)
          return s();
        y ? s(!1, y) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      y === 1 && !Ht(c, t.getBoundingClientRect()) && s(), O = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...v,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, v);
    }
    n.observe(t);
  }
  return s(!0), r;
}
function He(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = o, c = Rt(t), a = i || r ? [...c ? ot(c) : [], ...ot(e)] : [];
  a.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), r && w.addEventListener("resize", n);
  });
  const d = c && l ? We(c, n) : null;
  let h = -1, u = null;
  s && (u = new ResizeObserver((w) => {
    let [x] = w;
    x && x.target === c && u && (u.unobserve(e), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var v;
      (v = u) == null || v.observe(e);
    })), n();
  }), c && !f && u.observe(c), u.observe(e));
  let m, g = f ? U(t) : null;
  f && p();
  function p() {
    const w = U(t);
    g && !Ht(g, w) && n(), g = w, m = requestAnimationFrame(p);
  }
  return n(), () => {
    var w;
    a.forEach((x) => {
      i && x.removeEventListener("scroll", n), r && x.removeEventListener("resize", n);
    }), d?.(), (w = u) == null || w.disconnect(), u = null, f && cancelAnimationFrame(m);
  };
}
const ze = ae, Ie = fe, je = re, Ye = ue, Be = se, Ne = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: ke,
    ...n
  }, r = {
    ...i.platform,
    _c: o
  };
  return ie(t, e, {
    ...i,
    platform: r
  });
};
function $e(t) {
  return t != null && typeof t == "object" && "$el" in t;
}
function wt(t) {
  if ($e(t)) {
    const e = t.$el;
    return bt(e) && K(e) === "#comment" ? null : e;
  }
  return t;
}
function J(t) {
  return typeof t == "function" ? t() : Xt(t);
}
function qe(t) {
  return {
    name: "arrow",
    options: t,
    fn(e) {
      const n = wt(J(t.element));
      return n == null ? {} : Be({
        element: n,
        padding: t.padding
      }).fn(e);
    }
  };
}
function zt(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Vt(t, e) {
  const n = zt(t);
  return Math.round(e * n) / n;
}
function Xe(t, e, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = I(() => {
    var y;
    return (y = J(n.open)) != null ? y : !0;
  }), r = I(() => J(n.middleware)), s = I(() => {
    var y;
    return (y = J(n.placement)) != null ? y : "bottom";
  }), l = I(() => {
    var y;
    return (y = J(n.strategy)) != null ? y : "absolute";
  }), f = I(() => {
    var y;
    return (y = J(n.transform)) != null ? y : !0;
  }), c = I(() => wt(t.value)), a = I(() => wt(e.value)), d = nt(0), h = nt(0), u = nt(l.value), m = nt(s.value), g = jt({}), p = nt(!1), w = I(() => {
    const y = {
      position: u.value,
      left: "0",
      top: "0"
    };
    if (!a.value)
      return y;
    const A = Vt(a.value, d.value), E = Vt(a.value, h.value);
    return f.value ? {
      ...y,
      transform: "translate(" + A + "px, " + E + "px)",
      ...zt(a.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: u.value,
      left: A + "px",
      top: E + "px"
    };
  });
  let x;
  function v() {
    if (c.value == null || a.value == null)
      return;
    const y = i.value;
    Ne(c.value, a.value, {
      middleware: r.value,
      placement: s.value,
      strategy: l.value
    }).then((A) => {
      d.value = A.x, h.value = A.y, u.value = A.strategy, m.value = A.placement, g.value = A.middlewareData, p.value = y !== !1;
    });
  }
  function O() {
    typeof x == "function" && (x(), x = void 0);
  }
  function b() {
    if (O(), o === void 0) {
      v();
      return;
    }
    if (c.value != null && a.value != null) {
      x = o(c.value, a.value, v);
      return;
    }
  }
  function C() {
    i.value || (p.value = !1);
  }
  return dt([r, s, l, i], v, {
    flush: "sync"
  }), dt([c, a], b, {
    flush: "sync"
  }), dt(i, C, {
    flush: "sync"
  }), Yt() && qt(O), {
    x: G(d),
    y: G(h),
    strategy: G(u),
    placement: G(m),
    middlewareData: G(g),
    isPositioned: G(p),
    floatingStyles: w,
    update: v
  };
}
export {
  Ie as a,
  He as b,
  qe as c,
  je as f,
  ze as o,
  Ye as s,
  Xe as u
};
